export const ItemTypes = {
    GROSS_REVENUE: 'grossRevenue',
    NET_REVENUE: 'netRevenue',
    GROSS_PROFIT: 'grossProfit',
    CARD: 'card',
};
